/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HighRiskServiceRemoveResponse
 */
export interface HighRiskServiceRemoveResponse {
    /**
     * 
     * @type {string}
     * @memberof HighRiskServiceRemoveResponse
     */
    highRiskId?: string | null;
}

/**
 * Check if a given object implements the HighRiskServiceRemoveResponse interface.
 */
export function instanceOfHighRiskServiceRemoveResponse(value: object): value is HighRiskServiceRemoveResponse {
    return true;
}

export function HighRiskServiceRemoveResponseFromJSON(json: any): HighRiskServiceRemoveResponse {
    return HighRiskServiceRemoveResponseFromJSONTyped(json, false);
}

export function HighRiskServiceRemoveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighRiskServiceRemoveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'highRiskId': json['highRiskId'] == null ? undefined : json['highRiskId'],
    };
}

export function HighRiskServiceRemoveResponseToJSON(json: any): HighRiskServiceRemoveResponse {
    return HighRiskServiceRemoveResponseToJSONTyped(json, false);
}

export function HighRiskServiceRemoveResponseToJSONTyped(value?: HighRiskServiceRemoveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'highRiskId': value['highRiskId'],
    };
}

